import http from '../../../libs/http'
import config from '../../../config/shops'
export default (queryParams = {}) => http.get(`${config.api}/suppliers`, { params: { ...queryParams } })
